export function getNavigationItems(workspaceSlug: string) {
  return [
    { key: 'home', to: `/w/${workspaceSlug}`, label: 'Home' },
    { key: 'library', to: `/w/${workspaceSlug}/library`, label: 'Library' },
    { key: 'explore', to: `/w/${workspaceSlug}/explore`, label: 'Explore' },
  ] as const;
}

export const REPORTS_NAVIGATION_ITEM = { key: 'reports', to: '/reports/opportunity', label: 'Reports' } as const;

export type NavigationItem = ReturnType<typeof getNavigationItems>[number];
